export const CycleEvaluationGroupSteps = {
    CYCLE_INFORMATION: 'CycleInformation',
    EVALUATION_ELEMENTS: 'EvaluationElements',
    FEEDBACK_360_SETTINGS: 'Feedback360Settings',
    DEADLINES: 'Deadlines',
    COMMUNICATIONS: 'Communications',
} as const;

export type CycleEvaluationGroupStepsType =
    (typeof CycleEvaluationGroupSteps)[keyof typeof CycleEvaluationGroupSteps];
